//store配置
import QueryStore from '../module_biz/QueryScheme/store/QueryStore';
export default {
    queryStore: new QueryStore()
}
